import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GenericFilter } from 'projects/shared/src/lib/models/GenericFilter';
import { TenantDto, UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { UserProfileForCreation } from 'projects/shared/src/lib/models/UserProfileForCreation';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UserProfileService } from 'projects/shared/src/lib/services/user-profile.service';

@Component({
  selector: 'check-userlogin',
  templateUrl: './check-userlogin.component.html',
  styleUrls: ['./check-userlogin.component.css']
})
export class CheckUserloginComponent implements OnInit {

  isAuthenticated = false;
  userId = "";
  isConfirmed: boolean = false;
  user = new UserDto();
  isUserRetrieved = false;
  isTenantsRetrieved = false;
  userTenants: UserTenantDto[] = [];
  notConfirmedUserTenants: UserTenantDto[] = [];
  isNoTenantAssigned = false;
  isPwToChange = true;
  //newPwRequested = false;
  isPwChanged = false;
  //change: string = "---not changed---";

  constructor(
    private oauthService: OAuthServiceService,
    private accountService: AccountService,
    private userProfileService: UserProfileService,
    private tenantService: TenantService

  ) {}

  ngOnInit() {

    this.oauthService.userData.subscribe({
      next: (data: any) => {
        if (typeof data != undefined && data != null) {
          this.isAuthenticated = true;
          this.userId = data.sub;
          this.getUser(this.userId);
        }
      }
    });

    if(this.isAuthenticated) {
      this.checkUserConfirmation(this.userId);
    }
  }

  checkUserConfirmation(id: string){
    console.log("check-userlogin: checkUserConfirmation, id = ", id)
    this.tenantService.getUserTenantz(id, new GenericFilter).subscribe({
      next:(tenantDtos:UserTenantDto[]) => { 
        this.isTenantsRetrieved = true;
        if (tenantDtos.length == 0) {
          console.log("check-userlogin checkUserConfirmation: no tenant!")
          this.isNoTenantAssigned = true;
        }
        else{
          this.userTenants = tenantDtos;

          console.log("check-userlogin checkUserConfirmation: userTenants = ", tenantDtos)
  
          let confirmed = true;
          //let notConfirmedUserTenants: UserTenantDto[] = [];
          this.userTenants.forEach(function (userTenant) {
            if (!userTenant.isConfirmed) {
              confirmed = false;
              //notConfirmedUserTenants.push(userTenant);
            }
          })
          this.isConfirmed = confirmed;
          // alle (Basisdaten und Daten der einzelnen Tenants) werden aufgelistet. Die zu bestätigenden werden aufgeklappt
          //this.notConfirmedUserTenants = notConfirmedUserTenants; 
          // if (!this.isConfirmed)
          //   this.getUser(this.userId);
          // if (this.oneTenant) {
          //   this.tenantService.currentTenantName = this.userTenants[0].tenantName;
          //   this.tenantService.currentTenantDb = this.userTenants[0].tenantName;
          //   this.tenantService.currentTenantId = this.userTenants[0].tenantId;
          }   
      },
      error: (error: any) => {
      }
    });
    
    // this.accountService.isConfirmationLeft(id).subscribe({
    //   next:(toBeConfirmed:boolean) => { 
    //     if(!toBeConfirmed) {
    //       console.log("-----> user is confirmed")
    //       this.isConfirmed = true;
    //       //this.getUserTenants();
    //     }
    //   else {
    //     console.log("-----> user not confirmed")
    //     this.getUser(this.userId);
    //   }

    //   },
    //   error: (error: any) => {
    //   }
    // });
  }

  getUser(id: string) {
    // user from Main DB
    // users from tenant DBs are going to read in confirm-user (that is why notConfirmedUserTenants are passed to confirm-user (see .html))

    // this.accountService.getUserById(id).subscribe({
    // next:(userDto:UserDto) => { 
    //   this.user = userDto;
    //   this.isUserRetrieved = true;   
    //   console.log("--------> retrieved user = ", this.user)  
    // },
    // error: (error: any) => {
    // }
    console.log("check-userlogin: ============== getUserById =============")

    this.userProfileService.getUserById(id).subscribe({
      next:(userProfile: UserProfileForCreation) => {       
      this.user.id = id;
      this.user.email = userProfile.email;
      this.user.emailConfirmed = userProfile.isEmailConfirmed;
      this.user.first_Name = userProfile.givenName;
      this.user.last_Name = userProfile.familyName;
      this.user.phoneNumber = userProfile.phoneNumber;
      this.isUserRetrieved = true; 
      if (this.user.emailConfirmed) {
        this.isPwToChange = false;
      } else {
        (this.isPwChanged) ? this.isPwToChange = false : this.isPwToChange = true;
      }       
      console.log("--------> retrieved user = ", this.user)  
    }

    });

  }

  onChangePassword(){
    console.log("------> catch change event: changed");
    //this.newPwRequested = true;
    this.isPwChanged = true;
    this.ngOnInit();

  }

  onChange(user: UserDto){

    this.isConfirmed = true;
    this.userProfileService.currentUserName = user.first_Name + " " + user.last_Name;

    // this.isConfirmed = false;
    // this.isUserRetrieved = false;
    // this.checkUserConfirmation(user.id);
  }
}
